import { Box, BoxProps, Icon, Tooltip } from "@chakra-ui/react";
import LogRocket from "logrocket";
import React from "react";
import { IoPeople } from "react-icons/io5";

import { useSendGAEvent } from "../../../../utils/googleAnalytics";

interface CandidateOnlyToggleV2Props extends BoxProps {
  candidateOnly: boolean;
  setCandidateOnly(candidateOnly: boolean): void;
}

const CandidateOnlyToggleV2: React.FC<CandidateOnlyToggleV2Props> = ({
  candidateOnly,
  setCandidateOnly,
  ...rest
}) => {
  const sendGAEvent = useSendGAEvent();

  // candidateOnly=false means all speakers (on state)
  // candidateOnly=true means candidate only (off state)
  const isOn = !candidateOnly;

  return (
    <Tooltip label={isOn ? "Candidate Only" : "All Speakers"}>
      <Box
        as="button"
        data-intercom="candidate-only"
        display="flex"
        alignItems="center"
        justifyContent="center"
        w="24px"
        h="24px"
        borderRadius="full"
        bg={isOn ? "white" : "whiteAlpha.300"}
        cursor="pointer"
        transition="all 0.2s ease-in"
        _hover={{
          bg: isOn ? "gray.100" : "whiteAlpha.300",
        }}
        onClick={() => {
          LogRocket.track("candidate-only-toggle");
          sendGAEvent(
            "candidate_only_mode_toggle",
            "call_review",
            candidateOnly.toString()
          );
          setCandidateOnly(!candidateOnly);
        }}
        {...rest}
      >
        <Icon
          as={IoPeople}
          color={isOn ? "gray.900" : "gray.100"}
          w="16px"
          h="16px"
        />
      </Box>
    </Tooltip>
  );
};

export default CandidateOnlyToggleV2;
